export const DEFAULT_CHOROPLETH_MAP_COLORS = [
  '#F3FAF1',
  '#E4F6E3',
  '#CAEAC6',
  '#AFE0AA',
  '#7ACB71',
  '#62A25A',
  '#487A44',
];
export const DEFAULT_FILL_COLOR = '#dedede';
export const DEFAULT_HEIGHT = 500;
export const DEFAULT_WIDTH = '100%';
export const DEFAULT_ZOOM_LEVEL = 5;
export const FEATURE_OPACITY = 1;
export const FEATURE_DEFAULT_COLOR = 'white';
export const FEATURE_DEFAULT_WIDTH = 1;
export const FEATURE_HIGHLIGHTED_COLOR = 'yellow';
export const FEATURE_HIGHLIGHTED_WIDTH = 3;
export const MAP_TILE_URL = 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png';
export const SHOW_MARKERS_ZOOM = 6;
